var map = {
	"./ic_32_sport_american_football-active.svg": "a53b",
	"./ic_32_sport_basketball-active.svg": "afe1",
	"./ic_32_sport_eishockey-active.svg": "b6c5",
	"./ic_32_sport_fussball-active.svg": "d3d6",
	"./ic_32_sport_handball-active.svg": "929f",
	"./ic_32_sport_hockey-active.svg": "45a9",
	"./ic_32_sport_tennis-active.svg": "4422",
	"./ic_32_sport_tischtennis-active.svg": "018b",
	"./ic_32_sport_volleyball-active.svg": "4cbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a897";